import { Converter } from '../types/converter';

export const densityConverter: Converter = {
  id: 'density',
  name: 'Density Converter',
  icon: 'Scale',
  categories: ['engineering', 'fluids'],
  units: [
    // Base SI unit and common variants
    { name: 'Kilogram/cubic meter', symbol: 'kg/m³', factor: 1 },
    { name: 'Gram/cubic centimeter', symbol: 'g/cm³', factor: 1000 },
    { name: 'Kilogram/cubic centimeter', symbol: 'kg/cm³', factor: 1000000 },
    { name: 'Gram/cubic meter', symbol: 'g/m³', factor: 0.001 },
    { name: 'Gram/cubic millimeter', symbol: 'g/mm³', factor: 1000000 },
    { name: 'Milligram/cubic meter', symbol: 'mg/m³', factor: 0.000001 },
    { name: 'Milligram/cubic centimeter', symbol: 'mg/cm³', factor: 1 },
    { name: 'Milligram/cubic millimeter', symbol: 'mg/mm³', factor: 1000 },
    
    // Mass per liter units
    { name: 'Exagram/liter', symbol: 'Eg/L', factor: 1e18 },
    { name: 'Petagram/liter', symbol: 'Pg/L', factor: 1e15 },
    { name: 'Teragram/liter', symbol: 'Tg/L', factor: 1e12 },
    { name: 'Gigagram/liter', symbol: 'Gg/L', factor: 1e9 },
    { name: 'Megagram/liter', symbol: 'Mg/L', factor: 1e6 },
    { name: 'Kilogram/liter', symbol: 'kg/L', factor: 1000 },
    { name: 'Hectogram/liter', symbol: 'hg/L', factor: 100 },
    { name: 'Dekagram/liter', symbol: 'dag/L', factor: 10 },
    { name: 'Gram/liter', symbol: 'g/L', factor: 1 },
    { name: 'Decigram/liter', symbol: 'dg/L', factor: 0.1 },
    { name: 'Centigram/liter', symbol: 'cg/L', factor: 0.01 },
    { name: 'Milligram/liter', symbol: 'mg/L', factor: 0.001 },
    { name: 'Microgram/liter', symbol: 'µg/L', factor: 0.000001 },
    { name: 'Nanogram/liter', symbol: 'ng/L', factor: 1e-9 },
    { name: 'Picogram/liter', symbol: 'pg/L', factor: 1e-12 },
    { name: 'Femtogram/liter', symbol: 'fg/L', factor: 1e-15 },
    { name: 'Attogram/liter', symbol: 'ag/L', factor: 1e-18 },
    
    // Imperial/US units
    { name: 'Pound/cubic inch', symbol: 'lb/in³', factor: 27679.904710191 },
    { name: 'Pound/cubic foot', symbol: 'lb/ft³', factor: 16.018463373960138 },
    { name: 'Pound/cubic yard', symbol: 'lb/yd³', factor: 0.5932764212577829 },
    { name: 'Pound/gallon (US)', symbol: 'lb/gal (US)', factor: 119.826427 },
    { name: 'Pound/gallon (UK)', symbol: 'lb/gal (UK)', factor: 99.776373 },
    { name: 'Ounce/cubic inch', symbol: 'oz/in³', factor: 1729.994044387 },
    { name: 'Ounce/cubic foot', symbol: 'oz/ft³', factor: 1.001154 },
    { name: 'Ounce/gallon (US)', symbol: 'oz/gal (US)', factor: 7.489152 },
    { name: 'Ounce/gallon (UK)', symbol: 'oz/gal (UK)', factor: 6.236023 },
    { name: 'Grain/gallon (US)', symbol: 'gr/gal (US)', factor: 0.017118 },
    { name: 'Grain/gallon (UK)', symbol: 'gr/gal (UK)', factor: 0.014252 },
    { name: 'Grain/cubic foot', symbol: 'gr/ft³', factor: 0.002288 },
    
    // Special units
    { name: 'Ton (short)/cubic yard', symbol: 'ton (short)/yd³', factor: 1186.553 },
    { name: 'Ton (long)/cubic yard', symbol: 'ton (long)/yd³', factor: 1328.939 },
    { name: 'Slug/cubic foot', symbol: 'slug/ft³', factor: 515.379 },
    { name: 'Psi/1000 feet', symbol: 'psi/1000 ft', factor: 22.62 },
    { name: "Earth's density (mean)", symbol: 'ρ⊕', factor: 5515 }
  ]
};
